module.exports = __webpack_public_path__ + "img/chuangsai_40.4c34bd57.jpg";